import { jsonApi } from '../client';
import type { LoginResponse, RefreshRequest, SsoVerifyRequest } from './types';

const auth = jsonApi('auth');

const ssoVerify = (data: SsoVerifyRequest): Promise<LoginResponse> => {
  return auth.post('sso/verify', data);
};

const refresh = (data: RefreshRequest): Promise<LoginResponse> => {
  return auth.post('refresh', data);
};

const check = (): Promise<void> => {
  return auth.get('check');
};

export const authApi = {
  ssoVerify,
  refresh,
  check,
};
